import XLSX from 'xlsx'
// import { saveAs } from 'file-saver'
import { showLoad, hideLoad } from '@/tools/loading.js'

/* ----------------------- 导出 ----------------------- */

// 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
function getCharCol(n) {
  let s = ''
  let m = 0
  while (n > 0) {
    m = n % 26 + 1
    s = String.fromCharCode(m + 64) + s
    n = (n - m) / 26
  }
  return s
}

// 导出到excel
function json2Excel(data, downName, type) {
  // 处理表头
  let json = [{}]
  for (let k in data[0]) {
    json[0][k] = k
  }
  json = json.concat(data)

  let keyMap = [] // 获取键
  for (let k in json[0]) {
    keyMap.push(k)
  }
  // console.info('keyMap', keyMap, json)
  let tmpdata = [] // 用来保存转换好的json
  json.map((v, i) => keyMap.map((k, j) => Object.assign({}, {
    v: v[k],
    position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
  }))).reduce((prev, next) => prev.concat(next)).forEach(v => {
    tmpdata[v.position] = {
      v: v.v
    }
  })
  let outputPos = Object.keys(tmpdata) // 设置区域,比如表格从A1到D10
  let tmpWB = {
    SheetNames: ['sheet1'], // 保存的表标题
    Sheets: {
      'sheet1': Object.assign({}, tmpdata, {
        '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] // 设置填充区域
      })
    }
  }
  let tmpDown = new Blob([s2ab(XLSX.write(tmpWB,
    { bookType: (type === undefined ? 'xlsx' : type), bookSST: false, type: 'binary' } // 这里的数据是用来定义导出的格式类型
  ))], {
    type: ''
  }) // 创建二进制对象写入转换好的字节流
  var href = URL.createObjectURL(tmpDown) // 创建对象超链接
  const oA = document.createElement('a')
  document.body.appendChild(oA)
  oA.download = downName + '.xlsx' // 下载名称
  oA.href = href // 绑定a标签
  oA.click() // 模拟点击实现下载
  // 延时释放
  setTimeout(function () {
    URL.revokeObjectURL(tmpDown) // 用URL.revokeObjectURL()来释放这个object URL
  }, 100)
}

// 字符串转字符流
function s2ab(s) {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF
  }
  return buf
}

/* ----------------------- 导入 ----------------------- */
// that vue实例
// attr 接收数据的变量
// 导入excel
function importFile(that, attr) {
  // 创建input
  let imFile = document.createElement('input')
  imFile.setAttribute('type', 'file')
  imFile.setAttribute('id', 'imFile')
  imFile.setAttribute('accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel')
  imFile.style.display = 'none'
  document.body.appendChild(imFile)
  // 点击上传
  imFile.click()
  // 绑定change事件
  let $t = that
  let excelData = []
  imFile.onchange = () => {
    // this.fullscreenLoading = true
    showLoad()
    let obj = imFile
    if (!obj.files) {
      this.fullscreenLoading = false
      return
    }
    let f = obj.files[0]
    let reader = new FileReader()

    reader.onload = function (e) {
      let data = e.target.result
      if ($t.rABS) {
        // 手动转化
        $t.wb = XLSX.read(btoa(this.fixdata(data)), {
          type: 'base64'
        })
      } else {
        $t.wb = XLSX.read(data, {
          type: 'binary'
        })
      }
      let json = XLSX.utils.sheet_to_json($t.wb.Sheets[$t.wb.SheetNames[0]])
      excelData = dealFile(analyzeData(json)) // analyzeData: 解析导入数据
      that[attr] = excelData
      hideLoad()
    }
    if ($t.rABS) {
      reader.readAsArrayBuffer(f)
    } else {
      reader.readAsBinaryString(f)
    }
    // 销毁input
    document.body.removeChild(imFile)
    // return excelData
  }
}

function importExcel2(that, file, attr) {
  showLoad()
  let $t = that
  let reader = new FileReader()
  reader.readAsBinaryString(file)
  reader.onload = () => {
    let data = reader.result

    $t.wb = XLSX.read(data, {
      type: 'binary'
    })
    let json = XLSX.utils.sheet_to_json($t.wb.Sheets[$t.wb.SheetNames[0]])
    let excelData = json
    that[attr] = excelData
    hideLoad()
  }
}

// 此处可以解析导入数据
function analyzeData(data) {
  return data
}

// 处理导入的数据
function dealFile(data) {

  return data
}

export { json2Excel, importFile, importExcel2 }



// WEBPACK FOOTER //
// ./src/tools/excel.js